import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const get_all_coupons_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/coupons?${params}`
	);
	return response.data;
};

export const get_restaurant_stripe_status_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/stripe/onboard-restaurant/status/${params}`
	);
	return response.data;
};

export const add_coupons_api = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/coupons`,
		body
	);
	return response.data;
};

export const update_coupons_api = async ({ id, body }) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/coupons/${id}`,
		body
	);
	return response.data;
};

export const delete_coupons_api = async (params) => {
	const response = await authenticatedApi.delete(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/coupons/${params}`
	);
	return response.data;
};

export const get_coupons_byId_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/coupons/${params}`
	);
	return response.data;
};
